import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export default function JournalBasicInfoComponent({
  handleInnerFormChange, selectedJournals, ledgersList
}: any) {

   return (
     <>
       <AccordionContainer
         child={
           <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
             <InputContainer
               label="Reference Date"
               name="ReferenceDate"
               onValueChange={(event: any) => {
                 handleInnerFormChange(
                   event.target.value,
                   'ReferenceDate'
                 )
               }}
               type="date"
               value={selectedJournals?.ReferenceDate}
             />
             <InputContainer
               label="Source Ledger"
               labelField="LedgerName"
               list={ledgersList}
               onValueChange={(event: any) => {
                 handleInnerFormChange(
                   event.target.value,
                   'SourceLedgerId'
                 )
               }}
               optionName='Choose Source Ledger Name'
               type="select"
               value={selectedJournals?.SourceLedgerId}
               valueField="LedgerId"
             />
             <InputContainer
               label="Destination Ledger"
               labelField="LedgerName"
               list={ledgersList}
               onValueChange={(event: any) => {
                 handleInnerFormChange(
                   event.target.value,
                   'DestinationLedgerId'
                 )
               }}
               optionName='Choose Destination Ledger Name'
               type="select"
               value={selectedJournals?.DestinationLedgerId}
               valueField="LedgerId"
             />
             <InputContainer
               label="Amount"
               name="Amount"
               onValueChange={(event: any) => {
                 handleInnerFormChange(
                   event.target.value,
                   'Amount'
                 );
               }}
               type="number"
               value={selectedJournals?.Amount}
             />
           </div>
         }
        expandedPanel="userInfo"
        headerTitle="Basic Information"
      />
    </>
  )
}